import type { SuitabilityTestDefinition } from '../engine/types';
import { consilio } from './consilio';
import { lift } from './lift';
import { wioCapital } from './wio-capital';

/** Cada módulo está tipado con sus propias answers; el registro las unifica al bag del motor. */
type RegisteredTest = {
  current: SuitabilityTestDefinition<Record<string, unknown>>;
};

/** companyId (claim del token) → módulo de test. */
const WIO_CAPITAL_COMPANY_ID = '1';

const LIFT_COMPANY_ID = '4';

const CONSILIO_COMPANY_ID = '13';

/**
 * Registro de tests por `companyId`. Añadir una compañía nueva = registrar aquí
 * su módulo de tests.
 */
const REGISTRY: Record<string, RegisteredTest> = {
  [WIO_CAPITAL_COMPANY_ID]: wioCapital as unknown as RegisteredTest,
  [LIFT_COMPANY_ID]: lift as unknown as RegisteredTest,
  [CONSILIO_COMPANY_ID]: consilio as unknown as RegisteredTest,
};

/** Definición vigente para un `companyId`, o `undefined` si no tiene test. */
export const resolveCurrentTest = (
  companyId: string,
): SuitabilityTestDefinition<Record<string, unknown>> | undefined =>
  REGISTRY[companyId]?.current;
